module.exports = __webpack_public_path__ + "static/media/sourcesanspro-light-webfont.fb881861.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-light-webfont.ttf
// module id = 496
// module chunks = 0